import { render, staticRenderFns } from "./SelectionManagementTableColumn.vue?vue&type=template&id=f5118936&scoped=true&"
import script from "./SelectionManagementTableColumn.vue?vue&type=script&lang=js&"
export * from "./SelectionManagementTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./SelectionManagementTableColumn.vue?vue&type=style&index=0&id=f5118936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5118936",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
